import Swal from "sweetalert2";

/**
 * @param {string} message
 * @returns {Promise<SweetAlertResult>}
 */
const ConfirmDialog = async (
  message = "",
  cancelButtonName = "No",
  confirmButtonName = "Yes!"
) => {
  document.activeElement?.blur();

  return await Swal.fire({
    title: "Are you sure?",
    html: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: confirmButtonName,
    cancelButtonText: cancelButtonName,
    allowOutsideClick: false,
  });
};

export default ConfirmDialog;
